import { Box } from '@mui/material'
import Image from 'next/image'

const LoaderImage = ({ height = 50, width = 100 }: { height: number; width: number }) => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'transparent',
                zIndex: -9999
            }}
        >
            <Image
                src="https://ui.cltp.co/images/placeholder.png"
                alt="loader"
                height={height}
                width={width}
                fetchPriority="high"
                style={{ maxWidth: '100vw' }}
            />
        </Box>
    )
}

export default LoaderImage
